import { CommunityType } from 'types/communities';

import { getById, getManyByIds, Id, IdMap } from './idMap';

export { getById, getManyByIds };

export type CommunityMap = IdMap<CommunityType>;

export const getCommunityById = (communityMap: CommunityMap, id: Id | null | undefined): CommunityType | undefined =>
  getById(communityMap, id);

export const getCommunitiesByIds = (communityMap: CommunityMap, ids: Array<Id> | null | undefined): CommunityType[] =>
  getManyByIds(communityMap, ids);
